import { AppConfig } from '@/types/app'

// Environment variables with fallbacks
const getEnvVar = (key: string, fallback: string = ''): string => {
    if (typeof window !== 'undefined') {
        // Client-side environment variables (prefixed with REACT_APP_)
        return (window as Window & { ENV?: Record<string, string> }).ENV?.[key] || fallback
    }
    // Server-side or build-time environment variables
    return process.env[key] || fallback
}

export const appConfig: AppConfig = {
    name: 'Optimo',
    version: getEnvVar('REACT_APP_VERSION', '1.0.0'),
    environment: getEnvVar('NODE_ENV', 'development') as AppConfig['environment'],
    apiUrl: getEnvVar('REACT_APP_API_URL', 'https://api.optimo.com'),
    features: {
        analytics: getEnvVar('REACT_APP_ENABLE_ANALYTICS', 'true') === 'true',
        feedback: getEnvVar('REACT_APP_ENABLE_FEEDBACK', 'true') === 'true',
        notifications: getEnvVar('REACT_APP_ENABLE_NOTIFICATIONS', 'true') === 'true',
    },
}

// Helper functions
export const isDevelopment = appConfig.environment === 'development'
export const isProduction = appConfig.environment === 'production'
export const isStaging = appConfig.environment === 'staging'

// Feature flags
export const features = appConfig.features

// API configuration
export const apiConfig = {
    baseURL: appConfig.apiUrl,
    timeout: 10000,
    retries: 3,
}
